import axios from "axios";
import { installMaintenanceRetry } from "@/lib/maintenance-retry";

installMaintenanceRetry(axios);

import type { CreateClientConfig } from "./generated/client.gen";
import { serializeLaravelQuery } from "./query-serializer";
import { redirectRefundedTreeRefusal } from "@/lib/refunded-tree-access";

axios.interceptors.response.use(undefined, (error: unknown) => {
  redirectRefundedTreeRefusal(error);

  return Promise.reject(error);
});

// Generated fetch functions use the app's default axios instance, which sends the session's XSRF token, and throw on
// failed requests so React Query sees every error. Query strings follow Laravel's conventions (booleans as 1/0).
export const createClientConfig: CreateClientConfig = (config) => ({
  ...config,
  axios,
  baseURL: "",
  paramsSerializer: { serialize: serializeLaravelQuery },
  throwOnError: true,
});
